{
  "emailSlugLabel": "Email Slug",
  "tabs": {
    "authorizedAccounts": "Authorized Accounts",
    "fbos": "FBOs",
    "users": "Users",
    "faaMapping": "FAA Mapping",
    "announcements": "Announcements",
    "activity": "Activity",
    "movableObstacles": "Movable Obstacles",
    "towingEquipment": "Towing Equipment",
    "aircraft": "Aircraft",
    "labeling": "Labeling",
    "convertSvgs": "Convert SVGs",
    "systemStatus": "System Status",
    "quarantine": "Quarantine",
    "activation": "Activation"
  },
  "uberAdmin": {
    "renderJobHistory": {
      "title": "Render Job History",
      "description": "Recent jobs from Render (update-aircraft, movable obstacles, towing equipment). Auto-refreshes every 20 seconds.",
      "tooltips": {
        "forceRun": "Force Run resets the checksum and runs the job even if data hasn't changed. Useful for testing or ensuring all databases are synchronized.",
        "refreshing": "Refreshing job list..."
      },
      "buttons": {
        "forceRun": "Force Run",
        "running": "Running..."
      },
      "columns": {
        "jobType": "Job Type",
        "status": "Status",
        "created": "Created",
        "duration": "Duration",
        "dashboard": "Dashboard"
      },
      "jobTypes": {
        "updateAircraft": "Update Aircraft",
        "updateMovableObstacles": "Update Movable Obstacles",
        "updateTowingEquipment": "Update Towing Equipment"
      },
      "links": {
        "view": "View"
      }
    },
    "errorBoundary": {
      "title": "Something went wrong",
      "description": "An error occurred while loading this section. Please try refreshing the page."
    },
    "aircraftLastUpdated": {
      "columns": {
        "checksum": "Checksum",
        "lastUpdated": "Last Updated",
        "tableName": "Table Name"
      },
      "description": "Description",
      "notAvailable": "Not Available",
      "title": "Aircraft Last Updated"
    },
    "workerStatus": {
      "columns": {
        "lastChecked": "Last Checked",
        "status": "Status",
        "worker": "Worker"
      },
      "description": "Description",
      "notAvailable": "Not Available",
      "title": "Worker Status"
    }
  },
  "components": {
    "aircraftTable": {
      "searchPlaceholder": "Search aircraft...",
      "headers": {
        "make": "Make",
        "model": "Model",
        "length": "Length",
        "wingspan": "Wingspan",
        "tailHeight": "Tail Height",
        "status": "Status"
      },
      "status": {
        "deployed": "Deployed",
        "labeling": "Labeling",
        "locked": "Locked"
      }
    }
  },
  "announcementsAdmin": {
    "dialogTitle": {
      "new": "New Announcement",
      "edit": "Edit Announcement"
    },
    "labels": {
      "title": "Title",
      "body": "Body",
      "mediaType": "Media Type",
      "youtubeEmbed": "YouTube Embed Code",
      "uploadImage": "Upload Image",
      "changeImage": "Change Image",
      "actionLink": "Action Link (optional)",
      "linkButtonText": "Link Button Text (optional)",
      "expirationDate": "Expiration Date"
    },
    "helperText": {
      "youtubeEmbed": "Paste the iframe embed code from YouTube",
      "actionLink": "Enter a URL to add a clickable link to the announcement",
      "linkButtonText": "Default: 'Learn More'"
    },
    "placeholders": {
      "actionLink": "https://example.com",
      "linkButtonText": "Learn More"
    },
    "preview": {
      "expires": "Expires: "
    },
    "errors": {
      "titleRequired": "Title is required",
      "bodyRequired": "Body is required",
      "expirationRequired": "Expiration date is required",
      "invalidYouTube": "Please enter a valid YouTube iframe embed code",
      "videoUrlRequired": "Video URL is required when video is selected",
      "imageRequired": "Please upload an image",
      "invalidUrl": "Please enter a valid URL (e.g., https://example.com)",
      "saveFailed": "Failed to save announcement. Please try again."
    },
    "confirmDelete": "Are you sure you want to delete this announcement?",
    "buttons": {
      "create": "Create",
      "update": "Update",
      "uploading": "Uploading...",
      "cancel": "Cancel",
      "addAnnouncement": "Add Announcement",
      "preview": "Preview",
      "edit": "Edit",
      "delete": "Delete",
      "close": "Close"
    },
    "columns": {
      "title": "Title",
      "body": "Body",
      "media": "Media",
      "link": "Link",
      "status": "Status",
      "expires": "Expires",
      "actions": "Actions"
    },
    "status": {
      "active": "Active",
      "expired": "Expired"
    },
    "mediaTypes": {
      "none": "None",
      "image": "Image",
      "video": "Video"
    }
  },
  "quarantineTab": {
    "title": "Pending Tenants (Quarantine)",
    "description": "Aircraft that could not be matched to the FAA registry or aircraft library during data import. Select an aircraft to map inline, or use \"Remove & Retry\" to clear and wait for the next sync.",
    "successMessage": "No pending tenants - all imported aircraft have been successfully matched!",
    "buttons": {
      "refresh": "Refresh",
      "removeAndRetry": "Remove & Retry ({{count}})"
    },
    "tableHeaders": {
      "tailNumber": "Tail Number",
      "fbo": "FBO",
      "typeHint": "Type Hint",
      "mapToAircraft": "Map to Aircraft",
      "register": "Register",
      "source": "Source",
      "created": "Created"
    },
    "tooltips": {
      "registerExplainer": "Register tail number in FAA database. Uncheck for quote/placeholder tails.",
      "willAddToFaa": "Will add to FAA database",
      "quotePlaceholder": "Quote/placeholder - won't pollute FAA database",
      "placeholderWarning": "Looks like a placeholder tail - won't be added to FAA database unless checked"
    },
    "table": {
      "noPendingTenants": "No pending tenants",
      "mapping": "Mapping...",
      "selectAircraft": "Select aircraft"
    },
    "defaults": {
      "unknownFbo": "Unknown FBO",
      "unknownOperator": "Unknown",
      "unknownTypeHint": "Unknown"
    },
    "dialog": {
      "title": "Remove Pending Tenants & Retry",
      "description": "Remove {{count}} pending tenant(s) from the quarantine queue.",
      "autoRetryTitle": "Automatic Retry:",
      "autoRetryBody": "The next scheduled data sync (runs every 5 minutes) will automatically re-attempt to create these tenants. If you've fixed the FAA mapping (added the aircraft to the library or updated the faa_to_airplx table), the tenant will be created successfully.",
      "retryNote": "If the mapping is still missing, the tenant will be re-quarantined. You can then fix the mapping and try again.",
      "cancelButton": "Cancel",
      "confirmButton": "Remove & Retry on Next Sync",
      "removing": "Removing..."
    },
    "snackbar": {
      "removed": "Removed {{count}} pending tenant(s)",
      "mapFailed": "Failed to map aircraft"
    },
    "pendingCount": "Pending Count",
    "selectionCount": "Selection Count"
  },
  "aircraftAdmin": {
    "title": "Aircraft Database",
    "loading": "Loading aircraft data...",
    "status": {
      "locked": "Locked",
      "deployed": "Deployed",
      "labeling": "Labeling"
    },
    "exportHeaders": {
      "make": "Make",
      "model": "Model",
      "length": "Length",
      "wingspan": "Wingspan",
      "tailHeight": "Tail Height",
      "status": "Status",
      "id": "ID"
    },
    "aircraftDeployed": "Aircraft Deployed: <strong>{{count}}</strong>",
    "exportButton": "Export Aircraft List"
  },
  "aircraftPreview": {
    "selectPrompt": "Select an aircraft to preview",
    "noImage": "No image available",
    "editButton": "Edit",
    "fields": {
      "id": "ID:",
      "length": "Length:",
      "wingspan": "Wingspan:",
      "tailHeight": "Tail Height:",
      "linkedTo": "Linked To:"
    }
  },
  "flightBridgeStatus": {
    "title": "FlightBridge Integrations",
    "description": "FlightBridge syncs trip schedules and concierge reservations from external flight operations systems. Each FBO integration syncs incrementally based on webhooks and scheduled updates.",
    "columns": {
      "fbo": "FBO",
      "companyId": "Company ID",
      "status": "Status",
      "lastSync": "Last Sync",
      "error": "Error"
    },
    "never": "Never"
  },
  "recentActivity": {
    "noActivity": "No recent activity",
    "columns": {
      "user": "User",
      "fbo": "FBO",
      "timestamp": "Timestamp"
    }
  },
  "weeklyActivityTable": {
    "title": "Weekly Activity",
    "noData": "No activity data available for the selected period.",
    "exportButton": "Export TSV",
    "showTestFBOs": "Show Test FBOs",
    "columns": {
      "fbo": "FBO"
    },
    "metrics": {
      "totalCustomers": "Total Customers",
      "weeklyActive": "Weekly Active",
      "monthlyActive": "Monthly Active"
    },
    "footer": {
      "totalFBOs": "Total FBOs:"
    }
  },
  "superUserAdmin": {
    "loading": "Loading...",
    "columns": {
      "userId": "User ID",
      "name": "Name",
      "email": "Email",
      "fbo": "FBO",
      "action": "Action",
      "permissions": "Permissions"
    },
    "placeholders": {
      "none": "---",
      "searchUser": "Search for user",
      "searchFBO": "Search for FBO"
    },
    "buttons": {
      "edit": "Edit",
      "close": "Close",
      "save": "Save",
      "saving": "Saving..."
    },
    "roles": {
      "none": "None"
    },
    "moreChip": "+ {{count}} more",
    "dialog": {
      "title": "Edit User"
    }
  },
  "buttonRemoveFBO": {
    "button": "Remove FBO",
    "dialog": {
      "title": "Confirm FBO Removal",
      "message": "Are you sure you want to remove this FBO? This action cannot be undone.",
      "cancelButton": "Cancel",
      "confirmButton": "Confirm"
    }
  },
  "towingEquipmentAdmin": {
    "loading": "Loading towing equipment...",
    "buttons": {
      "addEquipment": "Add Equipment",
      "exportList": "Export Equipment List",
      "deploy": "Deploy"
    },
    "tooltips": {
      "deployOnlyProduction": "Deploy is only available on production (app.airplx.com)"
    },
    "confirmations": {
      "deleteMessage": "Are you sure you want to delete \"{{name}}\"?",
      "deployTitle": "Confirm deploy",
      "deployMessage": "Are you sure you want to deploy towing equipment updates?",
      "deployOkButton": "Go baby go!"
    },
    "errors": {
      "deleteFailed": "Failed to delete equipment: {{error}}",
      "nameRequired": "Please provide a name for the equipment.",
      "invalidDimensions": "Please provide valid values for all dimension fields. Dimensions must be positive numbers up to 1000 feet.",
      "createFailed": "Failed to create equipment. Please try again.",
      "saveFailed": "Failed to save equipment: {{error}}",
      "widthInvalid": "Width must be a positive number up to 1000 feet.",
      "lengthInvalid": "Length must be a positive number up to 1000 feet.",
      "heightInvalid": "Height must be a positive number up to 1000 feet."
    },
    "exportHeaders": {
      "name": "Name",
      "width": "Width",
      "length": "Length",
      "height": "Height",
      "towBarLength": "Tow Bar Length",
      "id": "ID"
    }
  },
  "movableObstacleAdmin": {
    "loading": "Loading obstacles...",
    "buttons": {
      "addObstacle": "Add Obstacle",
      "exportList": "Export Obstacle List",
      "deploy": "Deploy"
    },
    "tooltips": {
      "deployOnlyProduction": "Deploy is only available on production (app.airplx.com)"
    },
    "confirmations": {
      "deleteMessage": "Are you sure you want to delete \"{{name}}\"?",
      "deployTitle": "Confirm deploy",
      "deployMessage": "Are you sure you want to deploy?",
      "deployOkButton": "Go baby go!"
    },
    "errors": {
      "deleteFailed": "Failed to delete obstacle: {{error}}",
      "invalidDimensions": "Please provide valid values for all fields. Dimensions must be positive numbers up to 1000 feet.",
      "createFailed": "Failed to create obstacle. Please try again.",
      "saveFailed": "Failed to save obstacle: {{error}}",
      "widthInvalid": "Width must be a positive number up to 1000 feet.",
      "lengthInvalid": "Length must be a positive number up to 1000 feet.",
      "heightInvalid": "Height must be a positive number up to 1000 feet."
    },
    "exportHeaders": {
      "name": "Name",
      "width": "Width",
      "length": "Length",
      "height": "Height",
      "id": "ID"
    }
  },
  "aircraftMappingTab": {
    "coverage": "Coverage: {{percentage}}% ({{mappedTails}} / {{totalTails}})",
    "searchPlaceholder": "Search by FAA Manufacturer or Model",
    "filters": {
      "manufacturer": "Manufacturer",
      "country": "Country",
      "allCountries": "All",
      "unmatched": "Unmatched",
      "withSuggestions": "With Suggestions"
    },
    "tableHeaders": {
      "frequency": "Frequency",
      "faaManufacturer": "FAA Manufacturer",
      "faaModel": "FAA Model",
      "airplxAircraft": "AirPlx Aircraft"
    },
    "tooltips": {
      "frequencyAllCountries": "Total number of registered tail numbers for this aircraft type",
      "frequencyWithCountry": "Format: \"countryCount (totalCount)\" - Showing {{country}} registrations with worldwide total in parentheses. Sorted by {{country}} count.",
      "blacklist": "Blacklist this FAA type (drones, balloons, etc.)"
    },
    "snackbar": {
      "blacklisted": "Blacklisted \"{{manufacturer}} {{model}}\"",
      "blacklistFailed": "Failed to blacklist. Please try again.",
      "bulkApplySuccess": "Applied {{appliedCount}} mappings ({{skippedCount}} skipped)",
      "bulkApplyFailed": "Bulk apply failed: {{message}}",
      "reApplySuccess": "Re-applied pattern \"{{query}}\": {{appliedCount}} mappings ({{skippedCount}} skipped)",
      "reApplyFailed": "Re-apply failed: {{message}}",
      "patternDeleted": "Pattern deleted",
      "patternDeleteFailed": "Delete failed: {{message}}"
    }
  },
  "activation": {
    "overview": {
      "title": "User Activation Overview",
      "description": "Monitor and manage user activation progress across FBOs",
      "fboFilter": "FBO",
      "allFbos": "All FBOs",
      "searchPlaceholder": "Search by name or email",
      "filterLabel": "Status",
      "noData": "No users found",
      "viewDetails": "View details",
      "columns": {
        "user": "User",
        "fboName": "FBO",
        "state": "State",
        "autostackRuns": "AutoStack Runs",
        "checklist": "Checklist",
        "timeline": "Timeline",
        "mode": "Show Checklist",
        "actions": "Actions"
      },
      "states": {
        "pre": "Pre-activation",
        "shallow": "Shallow",
        "deep": "Deep"
      },
      "filters": {
        "all": "All users",
        "active": "Active only",
        "stalled": "Stalled",
        "deep": "Deep activated"
      }
    },
    "detail": {
      "title": "Activation Details",
      "userInfo": "User Information",
      "checklistProgress": "Checklist Progress",
      "adminControls": "Admin Controls",
      "auditLog": "Change History",
      "notes": "Internal Notes",
      "reason": "Reason for change",
      "reasonHelp": "Optional note for audit log",
      "notCompleted": "Not completed",
      "markComplete": "Mark complete",
      "uncheckStep": "Reset step (uncheck)",
      "controls": {
        "startDate": {
          "label": "Activation Started",
          "help": "Adjust for trial timing corrections",
          "update": "Update"
        },
        "windowDays": {
          "label": "Activation Window (Days)",
          "help": "Extend or shorten the activation period"
        },
        "threshold": {
          "label": "Deep Activation Threshold",
          "help": "How many AutoStack runs = deep activation"
        },
        "variant": {
          "label": "Checklist Style",
          "help": "Which UI variant to show",
          "options": {
            "sidebar": "Sidebar Panel",
            "floating": "Floating Card",
            "banner": "Top Banner"
          }
        },
        "forceDeep": {
          "label": "Force Deep Activation",
          "help": "Manually mark as deeply activated (rare)"
        }
      }
    }
  }
}
